import {
  SbBlokData,
  storyblokEditable,
  StoryblokComponent,
} from "@storyblok/react";
import { slugify } from "apps/website/utils/content/text";
import { IStoryBlokComponent } from "apps/website/components/page/api.types";
import {
  IArticleContentsHeading,
} from "apps/website/components/storyblok/article/StoryBlokArticleContents";

interface IArticleBlok extends SbBlokData {
  disable_lede?: boolean;
  body?: SbBlokData[];
}

// Only top-level section headings (h2) are listed in the "In this article" blok,
// matching the anchor ids rendered by `article_title` via `slugify()`.
const collectHeadings = (body: SbBlokData[] = []): IArticleContentsHeading[] => body
  .filter((nestedBlok) => nestedBlok.component === "article_title" && nestedBlok.tag === "h2" && nestedBlok.text)
  .map((nestedBlok) => {
    const text = String(nestedBlok.text);
    return { text, id: slugify(text) };
  });

const Article = ({ blok }: IStoryBlokComponent<IArticleBlok>) => {
  const headings = collectHeadings(blok.body);
  // The first `article_rich_text` block renders as the lede by default. Editors
  // can turn the enlarged lede styling off for the whole article via the
  // article-level `disable_lede` field.
  const firstRichTextUid = blok.body?.find(
    (nestedBlok) => nestedBlok.component === "article_rich_text",
  )?._uid;

  return (
    <div {...storyblokEditable(blok)} key={blok._uid}>
      { blok.body?.map((nestedBlok) => (
        <div {...storyblokEditable(nestedBlok)} key={nestedBlok._uid}>
          <StoryblokComponent
            blok={nestedBlok}
            headings={headings}
            isLede={nestedBlok._uid === firstRichTextUid && !blok.disable_lede}
          />
        </div>
      )) }
    </div>
  );
};

export default Article;
